import { render, staticRenderFns } from "./tabelaSerieHistorica.vue?vue&type=template&id=1e2572fc&scoped=true"
import script from "./tabelaSerieHistorica.vue?vue&type=script&lang=js"
export * from "./tabelaSerieHistorica.vue?vue&type=script&lang=js"
import style0 from "./tabelaSerieHistorica.vue?vue&type=style&index=0&id=1e2572fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2572fc",
  null
  
)

export default component.exports